import { render } from "./NewsInfo.vue?vue&type=template&id=4519150a&scoped=true&ts=true"
import script from "./NewsInfo.vue?vue&type=script&lang=ts"
export * from "./NewsInfo.vue?vue&type=script&lang=ts"

import "./NewsInfo.vue?vue&type=style&index=0&id=4519150a&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4519150a"]])

export default __exports__